import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createProject } from "../../services/api"; // Importa la función de la API
import Breadcrumbs from "../../components/BreadCrumbs";

const ProjectCreate = () => {
  const [projectData, setProjectData] = useState({
    nombre: "",
    descripcion: "",
    fecha_inicio: "",
    fecha_fin: "",
    estado: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setProjectData({
      ...projectData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createProject(projectData);
      navigate("projects"); // Redirige a la lista de proyectos después de la creación
    } catch (error) {
      console.error("Error al crear el proyecto", error);
    }
  };
  const handleBack = () => {
    navigate("/dashboard/projects"); // Navega de regreso al listado de proyectos
  };

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Projects", url: "/dashboard/projects" },
    { name: "Create Project", url: "/dashboard/projects/create" },
  ];

  return (
    <>
      <Breadcrumbs paths={breadcrumbPaths} />
      <h3>Crear Proyecto</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Nombre del Proyecto</label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="nombre"
              value={projectData.nombre}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Descripción</label>
          <div class="col-sm-10">
            <textarea
              className="form-control"
              name="descripcion"
              value={projectData.descripcion}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Fecha de Inicio</label>
          <div class="col-sm-10">
            <input
              type="date"
              className="form-control"
              name="fecha_inicio"
              value={projectData.fecha_inicio}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Fecha de Fin</label>
          <div class="col-sm-10">
            <input
              type="date"
              className="form-control"
              name="fecha_fin"
              value={projectData.fecha_fin}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Estado</label>
          <div class="col-sm-10">
            <select
              className="form-select"
              name="estado"
              value={projectData.estado}
              onChange={handleChange}
              required
            >
              <option value="">Seleccionar...</option>
              <option value="Nuevo">Nuevo</option>
              <option value="Finalizado">Finalizado</option>
              <option value="En progreso">En progreso</option>
            </select>
          </div>
        </div>
        <div style={{ textAlign: "end" }}>
          <button type="submit" className="btn btn-primary">
            Crear Proyecto
          </button>
          {/* Botón para regresar a la lista de proyectos */}
          <button
            type="button"
            className="btn btn-secondary ms-3"
            onClick={handleBack}
          >
            Regresar
          </button>
        </div>
      </form>
    </>
  );
};

export default ProjectCreate;
